/*
 * @Author: Sam
 * @Date: 2020-11-20 10:45:17
 * @LastEditTime: 2021-07-23 11:11:18
 * @LastEditors: Sam
 * @Description:
 * @FilePath: \resourcesf:\thework\tofba-client\src\api\public.js
 * @可以输入预定的版权声明、个性签名、空行等
 */
// /customer/importer/initData

import request from '@/utils/request'

// 公共信息
export function initData (data) {
  return request({
    url: '/setting/publicdata/initData',
    method: 'post',
    data,
  })
}
//获取新闻列表
export function officewebnews (data) {
  return request({
    url: '/setting/articlenews/clist',
    method: 'post',
    data,
  })
}
export function queryState (data) {
  return request({
    url: '/setting/countrystatedetail/queryById',
    method: 'post',
    data,
  })
}
export function queryAppleTitles (data) {
  return request({
    url: '/setting/applytitlematching/queryAppleTitlesByServeCompanyId',
    method: 'post',
    data,
  })
}

export function updateEntrustApple (data) {
  return request({
    url: '/seaair/seaairlist/updateEntrustApple',
    method: 'post',
    data,
  })
}
// 根据域名动态获取网站数据
export function getDomainInfo (data) {
  return request({
    url: '/user/organization/clientManage/findByDomainName',
    method: 'post',
    data,
  })
}
